import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  strict: true,
  routes: (_routes) => [
    {
      name: 'well-known',
      path: '/:pathMatch(^\.well-known/.*)',
      component: () => import('~/pages/empty.vue'),
      meta: { layout: false },
    },
    {
      name: 'events',
      path: '/:pathMatch(programma/):slug(.*)',
      component: () => import('~/pages/events.vue'),
    },
    {
      name: 'search',
      path: '/:pathSearch(nl/zoeken|en/search)',
      component: () => import('~/pages/search.vue'),
    },
    {
      name: 'slug',
      path: '/:pathMatch(.*)',
      component: () => import('~/pages/default.vue'),
    },
    {
      name: 'koop-kaarten',
      path: '/:pathMatch(programma/koop-kaarten)',
      component: () => import('~/pages/koop-kaarten.vue'),
    },
    {
      name: 'winkelmand',
      path: '/:pathMatch(winkelmand)',
      component: () => import('~/pages/winkelmand.vue'),
    },
  ],
}
